<div>
  @if (title) {
    <div class="my-2">
      <div class="row">
        <div class="col">
          <ion-label class="color-medium text-uppercase">{{ title }}</ion-label>
        </div>

        @if (this.information) {
          <div class="col-auto">
            <div class="pointer-hover" (click)="callInformation()">
              <i class="fa-regular fa-info-circle color-primary"></i>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
